import type { Bundle } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getBundles = async (): Promise<ServiceResponse<Bundle[]>> => {
  const response = await privateAPI.get<ServiceResponse<Bundle[]>>("/bundles");
  return response.data;
};
